import { RPCDocs, RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Events/hooks/useEvents.ts
RPCDocs.Events.GetEventsList.v1.StateFilter.Pending;
/**
* Get a list of Events.
* @param args
* @param opts
*/
function useEvents(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Events.GetEventsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useEvents };

//# sourceMappingURL=useEvents.js.map